// extracted by mini-css-extract-plugin
export default {"demo":"RoundingProperty_demo__PLyWf","roundingvalues":"RoundingProperty_roundingvalues__cWBYQ"};